import { ApiBind, Common } from './common.model';

export class SDKVersionGroupSDKVersion extends Common {
  @ApiBind({ column: 'sdk_version_id' })
  id: number;
}
